<template>
<div>
    <!--v-row class="ma-0 px-6">
        <v-autocomplete v-model="routine.user_id" :items="clientsList" :loading="isLoadingClients" :search-input.sync="searchClients" hide-no-data item-value="id" item-text="name" label="Paciente" placeholder="Escribe para buscar" attach></v-autocomplete>
    </v-row-->
    <v-row class="ma-0 px-6 mt-0 pt-6">
        <v-text-field class="ml-2" outlined dense v-model="routine.name" label="Nombre de la Rutina"></v-text-field>
    </v-row>
    <v-row class="ma-0">

        <v-col cols="3" class="pa-0 pt-8">
            <v-select v-model="routine.bloques" outlined dense label="Bloques" :items="bloques" style="transform:scale(.8);"></v-select>
            <v-expansion-panels multiple class="pa-3" v-model="panel">
                <v-expansion-panel class="my-1 pa-0" v-for="(day, index) in routine.days" v-bind:key="index">
                    <v-expansion-panel-header class="pl-0">
                        <v-row class="ma-0 mb-1 px-6">
                            <strong>{{day.title}}</strong>
                            <v-spacer/>
                            <v-icon @click="removeDay(index)" small color="#e12826">mdi-close</v-icon>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pa-0">
                        <div style="background:white; border-radius:4px;" class="px-0 pb-2">
                            <v-select v-model="day.muscular_groups" multiple chips outlined dense label="Grupos Musculares" :items="categories" item-text="name" item-value="name" style="transform:scale(.8);"></v-select>
                            <v-text-field v-model="day.duration" outlined dense label="Duración" type="number" suffix="hora(s)" style="transform:scale(.8);"></v-text-field>

                            <draggable :list="day.exercises_ids" :onEnd="onEnd()" class="list-group" draggable=".item" group="a">
                                <v-divider class="my-4"/>
                                <div v-for="(exercise, index) in day.exercises_ids" :key="index" class="list-group-item item">
                                    <v-card style="background:#eeee;" class="mx-5 my-2 py-1 elevation-0">
                                        <v-card-title class="py-0" style="font-size:12px;"><v-icon @click="exercises.push(exercise), day.exercises_ids.splice(index, 1)" small>mdi-close</v-icon>{{exercise.title}}</v-card-title>
                                        <v-row class="ma-0">
                                            <v-text-field v-model="exercise.series" outlined dense label="Series" style="transform:scale(.8); width:50%;"></v-text-field>
                                            <v-text-field v-model="exercise.reps" outlined dense label="Repeticiones" style="transform:scale(.8); width:50%;"></v-text-field>
                                        </v-row>
                                    </v-card>
                                    <v-divider class="my-4" v-if="multiplos(index+1)"/>
                                </div>
                            </draggable>

                        </div>                    
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <v-row class="ma-0">
                <v-spacer/>
                <v-btn @click="addDay" color="black" dark fab class="elevation-0 my-auto" x-small><v-icon>mdi-plus</v-icon></v-btn>
                <v-spacer/>
            </v-row>
        </v-col>

        <v-col cols="9" class="pa-0 pt-3 pr-3" >

            <v-card class="elevation-0 py-4 mt-1">
                <v-chip-group class="mb-4 mx-6">
                    <v-chip small v-if="!filters.categories.length" color="#e12826" dark>Todo</v-chip>
                    <v-chip small @click="filter(category.id)" :dark="isOnFilter(category.id)" :outlined="!isOnFilter(category.id)" :color="chipColor(category.id)" v-for="(category, index) in categories" :key="index">{{category.name}}</v-chip>
                </v-chip-group>
                <v-row class="ma-0">
                    <v-text-field v-model="filters.search" outlined dense label="Buscar..." style="transform:scale(.9); width:250px;"></v-text-field>
                    <v-select v-model="filters.dificult" multiple chips outlined dense style="transform:scale(.9); width:100px;" label="Dificultad"></v-select>
                </v-row>

                <v-row v-if="loading" class="ma-0 py-6 pl-7 pr-5">
                    <v-progress-linear  color="#e12826" indeterminate rounded height="6"></v-progress-linear>
                </v-row>

                

                <div class="ma-4" v-else>
                    <draggable style="height:100%!important;" :list="exercises" class="list-group" draggable=".item" group="a">
                        <v-card style="width:23%; display:inline-block; margin:1%;" class="list-group-item item" v-for="(exercice, index) in exercises" :key="index">
                            <!--mux-player
                                v-if="exercice.playback_id!=null"
                                stream-type="on-demand"
                                :playback-id="exercice.playback_id"
                                metadata-video-title="Placeholder (optional)"
                                metadata-viewer-user-id="Placeholder (optional)"
                                primary-color="#FFFFFF"
                                secondary-color="#000000">
                            </mux-player-->
                            <v-img v-if="exercice.playback_id!=null" :src="'https://image.mux.com/' + exercice.playback_id + '/thumbnail.jpg'"/>
                            <v-img v-else src="/video404.jpeg" height="105px" ></v-img>
                            <v-card-title style="font-weight:500; font-size:14px; line-height:18px;" class="pt-0 pb-2 my-2">
                                {{exercice.title}}
                            </v-card-title>
                            <v-card-subtitle style="font-weight:500; font-size:12px;" class="pb-1">
                                <strong>Nivel: </strong>{{exercice.difficulty}}
                            </v-card-subtitle>
                        </v-card>
                    </draggable>
                    <v-row class="ma-0 pt-2">
                        <v-pagination v-model="page" color="#e12826" :length="pages" circle class="elevation-0"></v-pagination>
                    </v-row>
                </div>

            </v-card>

            
        </v-col>

        <v-btn :loading="loader" v-if="this.selected_routine!=undefined && (this.routine.user_id == this.$route.params.id)" @click="save('modify')" bottom color="black" dark fab fixed right style="transform:translateY(-70px)!important;">
            <v-icon color="white">  mdi-content-save-edit-outline </v-icon> 
        </v-btn> 

        <v-btn :loading="loader" @click="save('create')" bottom color="#e12826" dark fab fixed right>
            <v-icon color="white">  mdi-content-save-outline </v-icon>
        </v-btn> 

        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-row>  
</div>
</template>

<script>
import axios from 'axios'
import draggable from 'vuedraggable'
import VueHorizontal from 'vue-horizontal';
export default {
    components: {
        draggable,
        VueHorizontal
    },
    data() {
        return {
            selected_routine:undefined,
            loader:false,
            page:1,
            pages:0,
            bloques:[2,3,4],
            panel:[],
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            routine:{
                name:'',
                assigned_by_user_id:'',
                user_id:'',
                bloques:'',
                days:[{
                    title:'Día 1',
                    muscular_groups:'',
                    duration:'',
                    exercises_ids:[{
                        title: '',
                        series:'',
                        reps:'',
                        id:'',
                        index: '',
                        logs: ''
                    }],
                }]
            },
            filters:{
                search:'',
                dificult:'',
                categories:[]
            },
            loading:true,
            exercises:[],
            isLoadingClients: false,
            searchClients: null,
            entries:{
                clients: []
            },
        };
    },
    watch:{
        isDirty:{
            handler(){
                if(this.isDirty){
                    localStorage.setItem('isDirty', true)
                }
            }, deep:true
        },
        page:{
            handler(){
                this.getDataFromApi()
            }, deep:true
        },
        filters:{
            handler(){
                this.getDataFromApi()
            },deep:true
        },
        searchClients(val){
            //if (this.clientsList.length > 0) return
            if (this.isLoadingClients) return
            this.isLoadingClients= true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/users?filter[name]="+val)
            .then(res => {
                if(this.entries.clients.length>0){
                    this.entries.clients.concat(res.data.data)
                }else{
                    this.entries.clients = res.data.data
                }
            }).finally(() => (this.isLoadingClients = false))
        },
    },
    created(){
        this.$store.dispatch('routines/getRoutines', this.$route.params.id)
        this.getDataFromApi()
        this.$emit("closeDrawer", false);
    },
    computed:{
        isDirty(){
            function isNotNullUndefinedOrEmpty(value) {
                return value !== null && value !== undefined && value !== '';
            }
            for (let key in this.routine) {
                if(key!='days'){
                    const value = this.routine[key];
                    if (isNotNullUndefinedOrEmpty(value)) {
                        return true
                    }
                }else{
                    if(this.routine.days.length>1){
                        return true
                    }else{
                        for (let key2 in this.routine.days[0]) {
                            if(key2!='title'&&key2!='exercises_ids'){
                                const value = this.routine.days[0][key2];
                                if (isNotNullUndefinedOrEmpty(value)) {
                                    return true
                                }
                            }else if(key2=='exercises_ids'){
                                if(this.routine.days[0].exercises_ids.length>1){
                                    return true
                                }else{
                                    for (let key3 in this.routine.days[0].exercises_ids[0]) {
                                        const value = this.routine.days[0].exercises_ids[0][key3];
                                        if (isNotNullUndefinedOrEmpty(value)) {
                                            return true
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        clientsList(){
            return this.entries.clients.map(id => {
                return{
                    id:id.id,
                    name:id.name
                }
            })
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        },
        categories(){
            return this.$store.state.category.categories
        }
    },
    methods: {
        onEnd(event) {
            
        },
        save(action){
            this.loader = true
            const routine = { ...this.routine }
            routine.assigned_by_user_id = this.currentUser.id
            routine.days = routine.days.map(id=>{return{
                title:id.title,
                muscular_groups:id.muscular_groups,
                duration:id.duration,
                exercises_ids:id.exercises_ids.map((item, index)=>{return{
                    id:item.id,
                    reps:item.reps,
                    series:item.series,
                    index: index,
                    logs: item.logs
                }}).sort((a,b) => b.index - a.index).map((item, index)=>{return{
                    id:item.id,
                    reps:item.reps,
                    logs:[],
                    series:item.series,
                    index: index,
                    logs: item.logs
                }}),
            }})

            if(action == 'create'){
                routine.user_id = null
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/workout_routines", routine).then(res => {
                    this.loader = false
                    this.routine = {
                        assigned_by_user_id:'',
                        user_id:'',
                        bloques:'',
                        days:[{
                            title:'Día 1',
                            muscular_groups:'',
                            duration:'',
                            exercises_ids:[{
                                title: '',
                                series:'',
                                reps:'',
                                id:'',
                                index: '',
                                logs: ''
                            }],
                        }]
                    }
                    this.getDataFromApi()
                    this.snackbar = {
                        show: true,
                        message: 'Rutina creada con éxito',
                        color: 'success'
                    }
                }).catch(error=>{
                    this.loader = false
                    this.snackbar = {
                        show: true,
                        message: 'Hubo un error al guadrar la rutina, verifica que los datos esten completos',
                        color: 'red'
                    }
                })
            }else if(action == 'modify'){
                axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/workout_routines/" + this.selected_routine, routine).then(res => {
                    this.loader = false
                    this.routine = {
                        assigned_by_user_id:'',
                        user_id:'',
                        bloques:'',
                        days:[{
                            title:'Día 1',
                            muscular_groups:'',
                            duration:'',
                            exercises_ids:[{
                                title: '',
                                series:'',
                                reps:'',
                                id:'',
                                index: '',
                                logs: ''
                            }],
                        }]
                    }
                    location.reload()
                    this.snackbar = {
                        show: true,
                        message: 'Rutina modificada con éxito',
                        color: 'success'
                    }
                }).catch(error=>{
                    this.loader = false
                    this.snackbar = {
                        show: true,
                        message: 'Hubo un error al guadrar la rutina, verifica que los datos esten completos',
                        color: 'red'
                    }
                })
            }


        },
        multiplos(numero){
            if(numero>0 && (( numero % this.routine.bloques ) == 0)) {
                return true
            }else{
                return false
            }
        },
        filter(category_id){
            var index = this.filters.categories.indexOf(category_id)
            if(index<0){
                this.filters.categories.push(category_id)
            }else{
                this.filters.categories.splice(index, 1)
            }
        },
        getDataFromApi () {
            this.loading = true
            this.apiCall().then(data => {
                this.pages = data.pages
                this.exercises = data.data.map(item=>{
                    return{
                    id:item.id,
                    reps:item.reps,
                    series:item.series,
                    playback_id:item.playback_id,
                    title:item.title,
                    dificult:item.dificult,
                }}),
                this.loading = false
            })
        },
        apiCall () {
            return new Promise((resolve, reject) => {
                var link = ''
                if(this.filters.search!=''){
                    link = link + 'filter[title]=' + this.filters.search + '&'
                }
                if(this.filters.dificult!=''){
                    link = link + 'filter[difficulty]=' + this.filters.dificult + '&'
                }
                if(this.filters.categories!=''){
                    link = link + 'filter[categories.id]=' + this.filters.categories + '&'
                }
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/videos?" + link + "&itemsPerPage=" + 40 + '&page=' + this.page).then(response => {
                    resolve({
                        //page:response.data.meta.current_page,
                        data:response.data.data,
                        pages:response.data.meta.last_page
                    })
                })
            })
        },
        chipColor(category_id){
            if(this.isOnFilter(category_id)){
                return '#e12826'
            }else{
                return 'grey'
            }
        },
        isOnFilter(category_id){
            if(this.filters.categories.indexOf(category_id)>=0){
                return true
            }else{
                return false
            }
        },
        addDay: function() {
            this.panel = [this.routine.days.length]
            this.routine.days.push({
                title:'Día ' + (this.routine.days.length+1),
                muscular_groups:'',
                duration:'',
                exercises_ids:[{
                    title: '',
                    series:'',
                    reps:'',
                    id:'',
                    index: '',
                    logs: ''
                }],
            })
        },
        removeDay(index) {
            this.routine.days.splice(index, 1);
        },
    }
};
</script>
<style>
    .scroll{
        overflow-y:scroll!important;
        max-height:50vh!important;
        -overflow-scrolling:touch!important;
        -webkit-overflow-scrolling:touch!important;
    }
    .v-text-field__details {
        display: none;
    }
    .v-expansion-panel-content__wrap {
        padding: 0px!important;
    }
    .v-expansion-panel::before {
        box-shadow: none!important;
    }
</style>